import WebViewManager from "./Shared/WebViewManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class NewClass extends cc.Component {
    start () {
        this.scheduleOnce(function () {
            cc.audioEngine.stopAll();
            cc.game.restart();
        }, 10)
    } 
}